import { Settings, Presentation} from "../../Settings";
import { ITransition } from "./ITransition";
import { ITransitionFactory, ITransitionParams, } from "./ITransitionFactory";

const transitionFactoryMap: Record<Presentation, (params: ITransitionParams) => Promise<ITransition>> = {
    [Presentation.VideoGameSprite]: async (params: ITransitionParams) => new (await import("./VideoSpriteTransition")).VideoSpriteTransition(params),
    [Presentation.VideoCommonNoSprite]: async (params: ITransitionParams) => new (await import("./VideoNoSpriteTransition")).VideoNoSpriteTransition(params),
    [Presentation.Image]: async (params: ITransitionParams) => new (await import("./ImageTransition")).ImageTransition(params),
    [Presentation.VideoCommonClassic]: async (params: ITransitionParams) => new (await import("./VideoSpriteTransitionClassicMix")).VideoSpriteTransitionClassicMix(params),
    [Presentation.VideoParticleTransitionMatterJS]: async (params: ITransitionParams) => new (await import("./VideoSpriteTransitionParticlesPIXiMatterJS")).VideoSpriteTransitionParticlesPIXiMatterJS(params),
    [Presentation.VideoParticleTransitionFadeInFadeOut]: async (params: ITransitionParams) => {throw "Its moved the PrepareResources and ResourcesLoaded into transition , need to use another the factory TransitionPIXIAPP"},
    [Presentation.VideoNoSprite]: async (params: ITransitionParams) => new (await import("./VideoNoSpriteTransition")).VideoNoSpriteTransition(params),
};

export class TransitionFactory implements ITransitionFactory {
    async Create(params: ITransitionParams): Promise<ITransition> {
        // if(params.transitionPIXITypeStyle == TransitionPIXITypeStyle.gameStyle){
        //     return new TransitionAnimationSpine(params);
        // }
        return transitionFactoryMap[Settings.PresentationType](params);
    }
}
